import React from 'react';
import {
  ButtonApprove,
  FieldCheckBox,
  FieldInput,
  FieldTextArea,
  FormCol,
  FormCol1,
  FormCol2,
  FormCol6,
  FormRow,
  useIsFieldRequiredHook,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { dateField, isActiveField } from 'shared-pages/common/form-helpfunc';
import { Col, Row } from 'react-bootstrap';
import { FileRepoField } from 'shared-pages/components/filerepo-field';
import { FileRepoImage } from 'shared-pages/components/filerepo-image';
import {
  isAfisCyprus,
  isRebattery,
  isFotokiklosi,
  isMedicycle,
  CompanyVatTitle,
} from 'shared-pages/common/constants';
import { PostalCodeAutocomplete } from '../../../components/field-select/postal-code-autocomplete';
import {
  FieldSelectNomos,
  FieldSelectRegion,
  FieldSelectSubregion,
  FieldSelectTaxoffice,
} from 'shared-pages/components';

export const FormFields = ({
  isNew,
  updateRecord,
  refetch,
  data,
  handleApprove,
  validationSchema = undefined,
}) => {
  //
  const { authStore, appStore } = useRootStore();
  const frmkCntx = useFormikContext();
  const { values } = frmkCntx;
  const isFieldRequired = useIsFieldRequiredHook(validationSchema);

  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();

  function calcUserCanEdit() {
    const canEdit = appStore.isPlatformOwner || isNew;
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();

  return (
    <div key={data?.id}>
      <FormRow>
        <FieldInput
          as={FormCol}
          label={t('Επωνυμία Εταιρείας')}
          name="name"
          placeholder=""
          disabled={!canEdit}
          required={isFieldRequired('name', values)}
        />
        <FieldInput
          as={FormCol}
          label={t('Υπεύθυνος')}
          name="contactperson"
          placeholder=""
          disabled={!canEdit}
        />
        <FieldInput
          as={FormCol}
          label={t('Α.Μ. ΗΜΑ (Συλλογή επικινδύνων)')}
          name="imaCode"
          placeholder=""
          disabled={!canEdit}
        />
        {isActiveField(t, canEdit, FormCol)}
      </FormRow>

      {/* 2η σειρά πεδίων */}
      <FormRow>
        <FieldInput
          as={FormCol}
          label={t('Διεύθυνση')}
          name="addressLine1"
          placeholder=""
          disabled={!canEdit}
          required={isFieldRequired('addressLine1', values)}
        />

        <FieldInput
          as={FormCol}
          label={t('Τηλέφωνο')}
          name="phone"
          placeholder=""
          disabled={!canEdit}
        />

        <FieldInput
          as={FormCol}
          label={t('Α.Μ. ΗΜΑ (Συλλογή Μη επικινδύνων)')}
          name="imaCode2"
          placeholder=""
          disabled={!canEdit}
        />

        {appStore.isPlatformOwner && (
          <FormCol>
            <FieldCheckBox
              className="w-100"
              disabled={true}
              label={t('Εγκεκριμένος Συλλέκτης')}
              name="isApproved"
              onLabel={t('ΝΑΙ')}
              offLabel={t('ΟΧΙ')}
            />
          </FormCol>
        )}
      </FormRow>

      {/* 3η σειρά πεδίων */}
      <FormRow>
        <FormCol>
          <Row>
            <FieldInput
              as={FormCol12}
              label={t('Διεύθυνση - 2η γραμμή')}
              name="addressLine2"
              placeholder=""
              disabled={!canEdit}
            />
          </Row>
          <Row>
            <FieldInput
              as={FormCol12}
              label={t('Περιοχή')}
              name="addressArea"
              placeholder=""
              disabled={!canEdit}
            />
          </Row>
        </FormCol>

        <FormCol>
          <Row>
            <FieldInput
              as={FormCol12}
              label={t('Κινητό')}
              name="mobile"
              placeholder=""
              disabled={!canEdit}
            />
          </Row>
          <Row>
            <FieldInput
              as={FormCol12}
              label={t('E-mail')}
              name="email"
              placeholder=""
              disabled={!canEdit}
            />
          </Row>
        </FormCol>

        <FieldTextArea
          as={FormCol}
          disabled={!canEdit}
          label={t('Παρατηρήσεις')}
          name="notes"
          type="text"
          rows={4}
          placeholder={t('')}
          required={false}
        />
        <FormCol>
          {appStore.isPlatformOwner && (
            <Row>
              <FieldInput
                as={FormCol6}
                label={t('Έγκριθηκε από')}
                name="approvedBy"
                disabled={true}
              />
              {dateField(t('Ημ/νία Έγκρισης'), 'approvedDate', t, false, FormCol6)}
            </Row>
          )}

          <Row>
            <FormCol12 className="d-flex align-items-center">
              {data?.isApproved === false && appStore.isPlatformOwner && (
                <ButtonApprove
                  onClick={() => handleApprove()}
                  text={t('Έγκριση')}
                  className="col-12"
                />
              )}
            </FormCol12>
          </Row>
        </FormCol>
      </FormRow>

      {/* 4η σειρά πεδίων */}

      <FormRow>
        <FieldInput
          as={FormCol}
          label={t('Πόλη')}
          name="addressCity"
          placeholder=""
          disabled={!canEdit}
        />
        <FieldInput
          as={FormCol}
          label={CompanyVatTitle}
          name="companyVat"
          placeholder=""
          disabled={!canEdit}
          required={isFieldRequired('companyVat', values)}
        />
        {appStore.isPlatformOwner && (
          <>
            <FieldInput
              as={FormCol1}
              label={t('Εγκρίθηκε από')}
              name="approvedBy"
              disabled={true}
            />
            {dateField(t('Ημ/νία Έγκρισης'), 'approvedDate', t, false, FormCol2)}
          </>
        )}
      </FormRow>
      <FormRow>
        {isFotokiklosi ? (
          <FormCol>
            <PostalCodeAutocomplete
              name="postalCode"
              label={t('T.K. :')}
              disabled={!canEdit}
              initialData={data}
            />
          </FormCol>
        ) : (
          <FieldInput
            as={FormCol}
            label={t('T.K.')}
            name="postalCode"
            placeholder=""
            disabled={!canEdit}
          />
        )}
        {!isAfisCyprus &&
          !isMedicycle &&
          (isFotokiklosi ? (
            <FieldSelectTaxoffice
              disabled={!canEdit}
              required={isFieldRequired('companyTaxOffice', values)}
              as={FormCol}
            />
          ) : (
            <FieldInput
              as={FormCol}
              label={t('Δ.Ο.Υ.')}
              name="companyTaxOffice"
              placeholder=""
              disabled={!canEdit}
              required={isFieldRequired('companyTaxOffice', values)}
            />
          ))}
      </FormRow>
      <FormRow>
        <FieldSelectNomos
          as={FormCol}
          name={'addressNomos'}
          defaultValues={{ data }}
          disabled={!canEdit}
        />
        <FieldSelectRegion
          as={FormCol}
          name="regionId"
          defaultValues={{ data }}
          disabled={!canEdit}
        />
        <FieldSelectSubregion
          as={FormCol}
          name="subregionId"
          defaultValues={{ data }}
          disabled={!canEdit}
        />
      </FormRow>
      <hr className="mb-3" />
      <FormRow>
        {!isRebattery && (
          <FieldInput
            as={FormCol}
            label={t('Αριθμός Σύμβασης')}
            name="contractNo"
            placeholder=""
            disabled={!canEdit}
          />
        )}
        {dateField(t('Ημερομηνία Υπογραφής Σύμβασης'), 'contractSignDate', t, canEdit, FormCol)}
        {dateField(t('Λήξη Σύμβασης'), 'contractExpDate', t, canEdit, FormCol)}
      </FormRow>
      <FormRow>
        <FieldInput
          as={FormCol}
          label={t('Αριθμός Ασφαλιστηρίου Αστικής Ευθύνης')}
          name="insurancePolicyNumber"
          placeholder=""
          disabled={!canEdit}
        />
        {dateField(
          t('Λήξη Ασφαλιστηρίου Αστικής Ευθύνης'),
          'insuranceExpirationDate',
          t,
          canEdit,
          FormCol,
        )}

        <FormCol>
          <Row style={{ margin: 0, marginBottom: '-15px' }}>
            <FileRepoField
              as={Col}
              label={t('Ανάρτηση Ασφαλιστηρίου Αστικής Ευθύνης')}
              fileIdFieldName="insuranceFileId"
              fileRec={data?.insuranceFilesrepository}
              canEdit={canEdit}
            />
            <FileRepoImage fileId={data?.insuranceFilesrepository?.id} height="64px" />
          </Row>
        </FormCol>
      </FormRow>
      <FormRow>
        <FieldInput
          as={FormCol}
          label={
            isRebattery
              ? t('Αρ. Πρωτ. / ΑΔΑ Άδειας Συλλογής Μπαταριών')
              : t('Άδεια Μεταφοράς Επικίνδυνων')
          }
          name="hazardousWastePermit"
          placeholder=""
          disabled={!canEdit}
        />
        {dateField(
          isRebattery ? t('Λήξη Άδειας Συλλογής Μεταφοράς Μπαταριών') : t('Άδεια Επικινδύνων'),
          'hazardousWasteExpDate',
          t,
          canEdit,
          FormCol,
        )}

        <FormCol>
          <Row style={{ margin: 0, marginBottom: '-15px' }}>
            <FileRepoField
              as={Col}
              label={t('Ανάρτηση Άδειας Συλλογής Μεταφοράς Μπαταριών')}
              fileIdFieldName="hazardousWastePermitFileId"
              fileRec={data?.hazardousWastePermitFilesrepository}
              canEdit={canEdit}
            />
            <FileRepoImage fileId={data?.hazardousWastePermitFilesrepository?.id} height="64px" />
          </Row>
        </FormCol>
      </FormRow>
      {/* <FormRow>
          <FieldInput
            as={FormCol}
            label={t('Περιβαντολογική Άδεια')}
            name="environmentalPermit"
            placeholder=""
            disabled={!canEdit}
          />
          {dateField(
            t('Λήξη Περιβαντολογικής Άδειας'),
            'envPermitExpirationDate',
            t,
            canEdit,
            FormCol,
          )}
        </FormRow> */}
      <FormRow>
        {dateField(t('Λήξη Συμφωνητικού με ΣΑΜΕΕ'), 'adrConsultantAgrExpDate', t, canEdit, FormCol)}
        <FormCol>
          <Row style={{ margin: 0, marginBottom: '-15px' }}>
            <FileRepoField
              as={Col}
              label={t('Ανάρτηση Συμφωνητικού με ΣΑΜΕΕ')}
              fileIdFieldName="adrFileId"
              fileRec={data?.adrFilesrepository}
              canEdit={canEdit}
            />
            <FileRepoImage fileId={data?.adrFilesrepository?.id} height="64px" />
          </Row>
        </FormCol>
        <FormCol>
          <Row style={{ margin: 0, marginBottom: '-15px' }}>
            <FileRepoField
              as={Col}
              label={t('Αποδεικτικό Εγγράφου Κατάθεσης Ανανέωσης Άδειας Συλλογής')}
              fileIdFieldName="proofColPermitRenewalFileId"
              fileRec={data?.proofColPermitRenewalFilesrepository}
              canEdit={canEdit}
            />
            <FileRepoImage fileId={data?.proofColPermitRenewalFilesrepository?.id} height="64px" />
          </Row>
        </FormCol>
      </FormRow>

      <FormRow>
        {dateField(t('Λήξη Πιστοποιητικού ΣΑΜΕΕ'), 'sameePermitExpDate', t, canEdit, FormCol)}
        <FormCol>
          <Row style={{ margin: 0, marginBottom: '-15px' }}>
            <FileRepoField
              as={Col}
              label={t('Ανάρτηση Πιστοποιητικού ΣΑΜΕΕ')}
              fileIdFieldName="sameePermitFileId"
              fileRec={data?.sameePermitFilesrepository}
              canEdit={canEdit}
            />
            <FileRepoImage fileId={data?.sameePermitFilesrepository?.id} height="64px" />
          </Row>
        </FormCol>
        {!isRebattery && (
          <FieldCheckBox
            disabled={!canEdit}
            as={FormCol2}
            label={t('Ύπαρξη GPS')}
            name="hasGps"
            onLabel={t('ΝΑΙ')}
            offLabel={t('ΟΧΙ')}
          />
        )}
      </FormRow>
    </div>
  );
};

const FormCol12 = (props) => (
  <Col sm={12} lg={12} xl={12} {...props}>
    {props.children}
  </Col>
);
